import User from '../../model/user'
import moment from 'moment';

export default function mapUser(data) {
    let dob = moment(data.dateOfBirth, moment.ISO_8601);
    return new User(data.id, data.firstName, data.lastName, dob.format("YYYY-MM-DD"), data.hcn, data.accessLevel, data.isDependent, data.email, data.hcnIssuer);
}